import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  getAxiosConfig,
  getMinioImage,
  getUpdatedImageUrlWithSize,
} from "../../../../../utils/helpers";
import Img from "../../../../../components/Img";
import CarasouelImages from "../../../../../components/CarasouelImages";
import { Spinner } from "@chakra-ui/react";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchInput from "../../../../../components/SearchInput";

const LIMIT = 20;

const Step_02_Select_Project = ({
  selectedProject,
  setSelectedProject,
  setSelectedProjectImageUrl,
  search,
  setSearch,
}) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const scrollableRef = useRef(null);
  // const [search, setSearch] = useState("");

  async function fetchProjects(page = 1) {
    try {
      if (page === 1) setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/project-showcases`,
        getAxiosConfig({ page, limit: LIMIT, search }),
      );
      const newProjects = data.results.filter((p) => p.isLive);
      setProjects((prev) =>
        page === 1 ? newProjects : [...prev, ...newProjects],
      );
      setCurrentPage(data.currentPage);
      if (data.currentPage >= data.totalPages) {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchProjects(1);
    setSelectedProjectImageUrl(null);
    setHasMore(true);
  }, [search]);

  const fetchMoreProjects = () => {
    fetchProjects(currentPage + 1);
  };

  return (
    <>
      <div className="py-2 sticky top-0 z-[100] bg-white">
        <SearchInput
          initialValue={search}
          debouncedChange={(val) => {
            setSearch(val);
            // setCurrentPage(1);
          }}
          delay={1000}
          placeholder="Search projects ..."
        />
      </div>
      {loading ? (
        <div className="flex items-center justify-center">
          <Spinner color="teal" colorScheme="teal" className="mx-auto" />
        </div>
      ) : projects.length === 0 ? (
        <div>No projects found.</div>
      ) : (
        <div
          id="step02-project-scroll"
          ref={scrollableRef}
          className="h-full overflow-y-auto overscroll-contain"
        >
          <InfiniteScroll
            dataLength={projects.length}
            next={fetchMoreProjects}
            hasMore={hasMore}
            scrollableTarget="step02-project-scroll"
            loader={
              <div className="flex justify-center py-2">
                <Spinner color="teal" colorScheme="teal" size="sm" />
              </div>
            }
          >
            <div className="grid grid-cols-2 gap-2">
              {projects.map((v) => (
                <div
                  key={v._id}
                  onClick={() => {
                    setSelectedProject(v._id, v.title);
                  }}
                  className={`h-48 w-full border flex flex-col ${selectedProject == v?._id ? "border-teal-400" : ""}`}
                >
                  <div className="grow overflow-hidden">
                    <CarasouelImages
                      images={
                        Array.isArray(v?.projectImages)
                          ? v?.projectImages?.map((img) =>
                              getUpdatedImageUrlWithSize(
                                getMinioImage(img, true),
                                [1, 1, 1],
                              ),
                            )
                          : []
                      }
                    />
                  </div>
                  <h2 className="text-xs text-center py-2">{v.title}</h2>
                </div>
              ))}
            </div>
          </InfiniteScroll>
        </div>
      )}
    </>
  );
};

export default Step_02_Select_Project;
